export const INITIALIZE_UPGRADE_WORKFLOW = 'INITIALIZE_UPGRADE_WORKFLOW';
export type INITIALIZE_UPGRADE_WORKFLOW = typeof INITIALIZE_UPGRADE_WORKFLOW;

export const INITIALIZE_UPGRADE_WORKFLOW_SUCCESS =
  'INITIALIZE_UPGRADE_WORKFLOW_SUCCESS';
export type INITIALIZE_UPGRADE_WORKFLOW_SUCCESS = typeof INITIALIZE_UPGRADE_WORKFLOW_SUCCESS;

export const INITIALIZE_UPGRADE_WORKFLOW_FAILED =
  'INITIALIZE_UPGRADE_WORKFLOW_FAILED';
export type INITIALIZE_UPGRADE_WORKFLOW_FAILED = typeof INITIALIZE_UPGRADE_WORKFLOW_FAILED;

export const UPDATE_UPGRADE_STEP_STATES = 'UPDATE_UPGRADE_STEP_STATES';
export type UPDATE_UPGRADE_STEP_STATES = typeof UPDATE_UPGRADE_STEP_STATES;

export const SAVE_UPGRADE_WORKFLOW = 'SAVE_UPGRADE_WORKFLOW';
export type SAVE_UPGRADE_WORKFLOW = typeof SAVE_UPGRADE_WORKFLOW;

export const SAVE_UPGRADE_WORKFLOW_SUCCESS = 'SAVE_UPGRADE_WORKFLOW_SUCCESS';
export type SAVE_UPGRADE_WORKFLOW_SUCCESS = typeof SAVE_UPGRADE_WORKFLOW_SUCCESS;

export const SAVE_UPGRADE_WORKFLOW_FAILED = 'SAVE_UPGRADE_WORKFLOW_FAILED';
export type SAVE_UPGRADE_WORKFLOW_FAILED = typeof SAVE_UPGRADE_WORKFLOW_FAILED;

export const SUBMIT_UPGRADE_WORKFLOW = 'SUBMIT_UPGRADE_WORKFLOW';
export type SUBMIT_UPGRADE_WORKFLOW = typeof SUBMIT_UPGRADE_WORKFLOW;

export const SUBMIT_UPGRADE_WORKFLOW_SUCCESS =
  'SUBMIT_UPGRADE_WORKFLOW_SUCCESS';
export type SUBMIT_UPGRADE_WORKFLOW_SUCCESS = typeof SUBMIT_UPGRADE_WORKFLOW_SUCCESS;

export const SUBMIT_UPGRADE_WORKFLOW_FAILED = 'SUBMIT_UPGRADE_WORKFLOW_FAILED';
export type SUBMIT_UPGRADE_WORKFLOW_FAILED = typeof SUBMIT_UPGRADE_WORKFLOW_FAILED;
